// MT Footer Currency Selector
class CurrencySelector {
  constructor() {
    this.container = document.querySelector('.mt-foot__currency');
    if (!this.container) return;

    this.button = this.container.querySelector('.mt-foot__currency-button');
    this.currentLabel = this.container.querySelector('.mt-foot__currency-current');
    this.dropdown = this.container.querySelector('.mt-foot__currency-dropdown');
    this.options = this.container.querySelectorAll('.mt-foot__currency-option');

    this.init();
  }

  init() {
    // Toggle dropdown
    this.button.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    // Select currency option
    this.options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectCurrency(option);
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeDropdown();
      }
    });
  }

  toggleDropdown() {
    const isOpen = this.container.classList.contains('active');
    if (isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.container.classList.add('active');
    this.button.setAttribute('aria-expanded', 'true');
  }

  closeDropdown() {
    this.container.classList.remove('active');
    this.button.setAttribute('aria-expanded', 'false');
  }

  selectCurrency(option) {
    const currencyText = option.textContent.trim();
    const countryCode = option.dataset.country; // country ISO code e.g. "US", "GB"

    // Update button label immediately for visual feedback
    this.currentLabel.textContent = currencyText;

    // Close dropdown
    this.closeDropdown();

    // Use Shopify's official localization form to actually change the country/currency.
    // Shopify's /localization endpoint accepts country_code (ISO country code).
    const localizationForm = document.getElementById('mt-localization-form');
    if (localizationForm) {
      const codeInput = document.getElementById('mt-country-code-input');
      if (codeInput) codeInput.value = countryCode;
      const returnInput = localizationForm.querySelector('input[name="return_to"]');
      if (returnInput) returnInput.value = window.location.pathname + window.location.search;
      localizationForm.submit();
      return;
    }

    // Fallback: build form dynamically
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';

    const countryInput = document.createElement('input');
    countryInput.type = 'hidden';
    countryInput.name = 'country_code';
    countryInput.value = countryCode;

    const returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = window.location.pathname + window.location.search;

    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'authenticity_token';
    const existingToken = document.querySelector('meta[name="authenticity_token"]')
      || document.querySelector('input[name="authenticity_token"]');
    tokenInput.value = existingToken ? (existingToken.content || existingToken.value) : '';

    form.appendChild(countryInput);
    form.appendChild(returnToInput);
    form.appendChild(tokenInput);
    document.body.appendChild(form);
    form.submit();
  }

  // Load saved currency on page load
  // NOTE: The button label is now rendered server-side from localization.country,
  // so no localStorage override is needed. The server is the single source of truth.
  loadSavedCurrency() {
    // No-op: label is driven by Shopify's server-side localization object
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const currencySelector = new CurrencySelector();
    currencySelector.loadSavedCurrency();
  });
} else {
  const currencySelector = new CurrencySelector();
  currencySelector.loadSavedCurrency();
}
